import { useState,useEffect } from "react";
import { useDispatch,useSelector } from "react-redux";
import reload from "../../assets/icons/reload.svg";
import CustomTabsV2 from "../universal/CustomTabsV2";
import CollapsibleRightPanel from "../universal/CollapsibleRightPanel";
import {AddChurchHooks}  from "../../screens/Carcells/hooks/carcellshooks";
import { AllChurchHooks } from "../../screens/Carcells/hooks/carcellshooks";
import DropdownWithTags from "../universal/DropdownWithTags";
import LayoutDropdown from "../universal/LayoutDropdown";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import edit from "../../assets/icons/edit.svg";
import close from "../../assets/icons/close.svg";
import ReactModal from "react-modal";
import { ImCross } from "react-icons/im";
import LanguageDrawer from "../universal/LanguageDrawer";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { FaInfoCircle } from "react-icons/fa";
import UploadControlsV2 from "../TWG/UploadControlsV2";
import RelatedVideoInput from "../categories/RelatedVideoInput";
import VideoLibraryModal from "../TWG/VideoLibraryModal";
import GoogleMapInput from '../../components/MapInput/MapInput'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { parseISO } from "date-fns";
import { format } from "date-fns";
import GalleryPickerField from "../../components/ImageGallery/GalleryPickerField"
import GalleryVideoField from "../../components/videoGallery/GalleryPickerField"
import ReactQuill from "react-quill";
import { toast } from "react-toastify";
const AddVideosFields = ({ setLoading, data,rowData ,onClose,church}) => {
  // const { options } = GetRelatedVideosHooks();
  const dispatch = useDispatch();

   const {
    activeTab,
    activeLanguageDetails,
    setActiveLanguageDetails,
    setActiveTab,
    handleInputChange,
    handleFileInputChange,
    handleSave,
    handleSaveCarecellCoverImage,
    readLanguageData,
    videoInputs,
    selectedVideos, setSelectedVideos,
    videoErrors,
    videoUrlsInputs,
    showVideoLibraryModal,
    setShowVideoLibraryModal,
    setVideoUrlsInputs,
    setDownloadUrlsInputs,
    setTumbNailUrlsInputs,
    tumbNailUrlsInputs,
    UdownloadrlsInputs,
    handleChange,
    // handleRepeatEveryChange,
    handleCarecellChange,
    selectedOptions,
    setSelectedOptions,
    deleteRelatedVideo,
    setSelectedRelatedVideoIndex,
    handleDropdownChange,
    setLayoutValues,
    handleVideoLayoutChange,
    layoutValues,
    initialLayoutValues,
    setLayoutInfo,
    layoutInfo,
    handleDateChange,
    handleAddLayoutToArray,
    layoutArray,
    setAddedLayout,
    addedLayout,
    handleVideoDateChange,
    options,
    handleDeleteLayoutFromArray,
    setIsLayoutEdit,
    isLayoutEdit,
    setEditLayoutIndex,
    setEditTargetLayout,
    editTargetLayout,
    handleLayoutUpdate,
    updateStateWithTranslation,
    handleCommonTumbNailInputChange,
    setCommonUrlsInputs,
    commonVideoUrlsInputs,
    previewUrlsInputs,
    setPreviewUrlsInputs,
    languagemeta,
    setIsLanguageSave,
    handleSaveLanguage,
    handleLibraryVideoSelection,
    handleSendNotification,
    handleUpdateChurch,
    churchInputs,
    handleToggleMeetingDay,
    handleRemoveMonthlyDate,
    handleAddMonthlyDate,
    setImageSet,
    thumbnailImage, setThumbnailImage,
    isLive,setIslive,
    isDefault,setIsDefault,

    setChurchInputs
  } = AddChurchHooks(setLoading, data);
  const todayStr = format(new Date(), "yyyy-MM-dd");

  const [showModal, setShowModal] = useState(false);
  const [isImage, setIsImage] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");
  const [selectedLocation, setSelectedLocation] = useState({
    lat: "",
    lng: "",
    address: ""
  });
                      const carecellCover = useSelector((state) => state.churches.carecellcover);
const handleGallerySelect = (imageSet) => {
  setImageSet(imageSet)
      setTumbNailUrlsInputs({
      webUploadUrl: imageSet?.target?.value?.web?.url || "",
      tabletUploadUrl: imageSet?.target?.value?.tablet?.url || "",
      mobileUploadUrl: imageSet?.target?.value?.mobile?.url || "",
    });

  };
  const [description, setDescription] = useState(rowData?.description || "");
  const [apiCarecell, setApiCarecell] = useState(null);
const { fetchAllChurches } = AllChurchHooks();

  useEffect(() => {
    if (!rowData?.carecellObjId || !church?._id) return;

    fetchAllChurches(
      1,
      100,
      {},
      (res) => {
        if (!res?.data?.length) return;

        // 🔥 Carecell is already FLATTENED
        const carecell = res.data.find(
          (c) => c.carecellObjId === rowData.carecellObjId
        );

        if (carecell) {
          setApiCarecell(carecell);
        }
      },
      church._id
    );
  }, [rowData?.carecellObjId, church?._id]);

  useEffect(() => {
    if (!apiCarecell) return;

    setChurchInputs({
      church_id: apiCarecell.churchId,
      name: apiCarecell.name || "",
      description: apiCarecell.description || "", // ✅ HTML preserved
      placename: apiCarecell.placename || "",
      latitude: apiCarecell.latitude || "",
      longitude: apiCarecell.longitude || "",
      meetingday: apiCarecell.day || "",
      startmeetingtime: apiCarecell.startfrom || "",
      meetingtime: apiCarecell.endsat || "",
      repeat: apiCarecell.repeat || "Weekly",
      contactperson: apiCarecell.contactperson || "",
      contactphone: apiCarecell.contactphone || "",
      contactemail: apiCarecell.contactemail || "",
    });

    // 🔥 ReactQuill source of truth
    setDescription(apiCarecell.description || "");
  }, [apiCarecell]);

  const handleThumbSelect = (e) => {
    const videos = e?.target?.value || [];

  // normalize to array of ids
  const videoIds = videos.map((v) => v?.id).filter(Boolean);

  setSelectedVideos(videoIds);

  };
  const isQuillEmpty = (value) => {
    const div = document.createElement("div");
    div.innerHTML = value || "";
    return !div.textContent?.trim();
  };
  const validateCarecellFields = () => {
    if (!churchInputs?.name?.trim()) {
      toast.error("Name is required");
      return false;
    }

    if (
      !churchInputs?.description ||
      isQuillEmpty(churchInputs.description)
    ) {
      toast.error("Description is required");
      return false;
    }

    if (!churchInputs?.placename?.trim()) {
      toast.error("Place name is required");
      return false;
    }



    if (!churchInputs?.meetingday || churchInputs.meetingday.length === 0) {
      toast.error("Select at least one meeting day");
      return false;
    }

    if (!churchInputs?.startmeetingtime) {
      toast.error("Start time is required");
      return false;
    }

    if (!churchInputs?.meetingtime) {
      toast.error("End time is required");
      return false;
    }

    if (!churchInputs?.contactperson?.trim()) {
      toast.error("Contact person is required");
      return false;
    }

    if (!churchInputs?.contactphone?.trim()) {
      toast.error("Contact phone is required");
      return false;
    }

    if (!churchInputs?.contactemail?.trim()) {
      toast.error("Contact email is required");
      return false;
    }


    return true;
  };
  const cleanHtmlContent = (htmlContent) => {
    if (!htmlContent) return htmlContent;

    // Remove ALL color-related styles and formatting
    return htmlContent
      // Remove background-color styles
      .replace(/style="[^"]*background-color[^;"]*;?[^"]*"/gi, '')
      // Remove color styles
      .replace(/style="[^"]*color:[^;"]*;?[^"]*"/gi, '')
      // Remove any style attribute that contains color (more comprehensive)
      .replace(/style="[^"]*(color|background|background-color)[^"]*"/gi, '')
      // Remove any style attributes with single quotes
      .replace(/style='[^']*'/gi, '')
      // Remove empty style attributes
      .replace(/style=""/gi, '')
      // Remove any span tags that might have had styling (keeps span but removes all styles)
      .replace(/<span[^>]*>/gi, '<span>')
      // Remove any font tags that might bring color
      .replace(/<font[^>]*>/gi, '')
      .replace(/<\/font>/gi, '')
      // Also remove any color-related CSS classes
      .replace(/class="[^"]*color[^"]*"/gi, '');
  };
  return (
    <div className="flex flex-col md:flex-row h-full w-full flex-1 rounded-2xl overflow-hidden">
      <div className="flex h-full flex-1">
        <LanguageDrawer
          languageData={readLanguageData}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setActiveLanguageDetails={setActiveLanguageDetails}
          languagemeta={languagemeta}
          setIsLanguageSave={setIsLanguageSave}
        />
        <div className="flex h-full flex-1">
          <div className="flex flex-col h-full w-full bg-greyishV2 bg-opacity-50 md:border-l md:border-r border-greyish border-opacity-30 overflow-auto">
            <div className="flex gap-4 items-center justify-between h-[64px] px-4 border-b border-[#28292a]">
              <p className="text-white font-semibold text-lg">
                {activeTab === "en"
                  ? "Add Carecell"
                  : `Translate Churche to ${activeLanguageDetails?.language_name}`}
              </p>
              <div className="flex items-center gap-5">
                {activeTab !== "en" && data?._id && (
                  <p
                    className="flex items-center gap-1 text-greyish text-[11px] font-medium cursor-pointer whitespace-nowrap"
                    onClick={updateStateWithTranslation}
                  >
                    <img src={reload} alt="" /> Auto fill data with google translation
                  </p>
                )}
                {data?._id && (
                  <button
                    className="text-yellowish bg-blackish font-medium text-[12px] whitespace-nowrap border border-yellowish rounded-xl py-2 px-6"
                    onClick={handleSendNotification}
                  >
                    Send Notification
                  </button>
                )}
                {activeTab === "en" ? (
                  <div className="w-full flex items-end justify-end gap-4">
                    {/* <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      onClick={handleSave}
                    >
                      {rowData?._id ? "Update Church" : "Save Church"}
                    </button> */}
                    {
                      rowData?.carecellObjId ?
                      <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      // onClick={() => handleUpdateChurch(rowData)}s
                      onClick={async () => {
                        try {
                          await handleUpdateChurch(rowData); // wait until API completes and toast appears
                          onClose();          // now close the modal
                        } catch (err) {
                                                    // optionally keep modal open or close anyway
                        }
                      }}
                    >Update Carecell</button>
                    :
                    <button
                    className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                    onClick={async () => {
                      if (!validateCarecellFields()) return;

                      try {
                        await handleSave(church._id, onClose);
                        onClose();
                      } catch (err) {
                                              }
                    }}

                  >Save Carecell</button>
                    }
                  </div>
                ) : data?._id ? (
                  <div className="w-full flex items-end justify-end gap-4">
                    <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      onClick={handleSaveLanguage}
                    >
                      Save Language
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
            {/* TAB CONTENT  */}
            {activeTab !== "en" && !data?._id ? (
              <div className="flex items-center justify-center text-white gap-1 py-28">
                Church translation in{" "}
                <span className="italic">{activeLanguageDetails?.language_name}</span> is available
                for saved churches
              </div>
            ) : (
              <div className="px-4 my-4 h-full">
              <div className="overflow-y-auto overflow-x-hidden px-2">
              <div className="grid md:grid-cols-2 grid-cols-1 grid-rows-1 gap-x-4 gap-y-4 mx-1 w-full">
  {/* Church Name */}
  <div className="md:col-span-2 col-span-1 relative">
  <label className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2">
     Church *
  </label>

  <input
    type="text"
    name="church_id"
    placeholder="Enter Church Name"
    className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
    value={church ? church.churchName : ""}

    readOnly
  />

  {videoErrors?.church_id && (
    <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
      Church selection is required
    </p>
  )}
</div>

  <div className="md:col-span-2 col-span-1">
    <label className="text-[12px] text-greyish font-medium leading-4">
       Name *
    </label>
    <input
      name="name"
      placeholder="Enter Name"
      type="text"
      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
      value={churchInputs?.name}
      onChange={handleChange}
    />
  </div>

  {/* Church Description */}
{/* Church Description */}
<div className="md:col-span-2 col-span-1">
  <label className="text-[12px] text-greyish font-medium leading-4">
    Description *
  </label>

  <div className="mt-2">
    <ReactQuill
      theme="snow"
      value={description} // controlled value
      onChange={(value) => {
        const cleanedValue = cleanHtmlContent(value); // Clean the HTML content
        setDescription(cleanedValue); // update local state
        handleChange({ target: { name: "description", value: cleanedValue } }); // propagate to parent form
      }}
      placeholder="Enter Description"
      className="text-white text-[14px] font-medium rounded-md bg-blackish quill-custom"
    />
  </div>

  {videoErrors?.description && (
    <p className="text-red-500 text-[10px] left-2">
      Description is required
    </p>
  )}
</div>

  {/* Map Location (Place Name, Lat, Lng) */}
  <div className="md:col-span-2 col-span-1">
    <GoogleMapInput
      Location={{
        lat: churchInputs?.latitude || "",
        lng: churchInputs?.longitude || ""
      }}
      onLocationChange={({ lat, lng, address }) => {
        setSelectedLocation({ lat, lng, address });

        handleChange({
          target: { name: "placename", value: address }
        });
        handleChange({
          target: { name: "latitude", value: lat }
        });
        handleChange({
          target: { name: "longitude", value: lng }
        });
      }}
    />
  </div>

  {/* Place Name */}
  <div className="md:col-span-2 col-span-1">
    <label className="text-[12px] text-greyish font-medium leading-4">
      Place Name *
    </label>
    <input
      type="text"
      name="placename"
      placeholder="Enter Place Name"
      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
      value={selectedLocation?.address ||churchInputs?.placename|| ""}
      onChange={handleChange}
    />
  </div>

  {/* Latitude */}
  <div className="md:col-span-1 col-span-1 hidden">
    <label className="text-[12px] text-greyish font-medium leading-4">
      Latitude *
    </label>
    <input
      type="text"
      name="latitude"
      placeholder="Latitude"
      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
      value={selectedLocation?.lat || churchInputs?.latitude|| ""}
      onChange={handleChange}
    />
  </div>

  {/* Longitude */}
  <div className="md:col-span-1 col-span-1 hidden">
    <label className="text-[12px] text-greyish font-medium leading-4">
      Longitude *
    </label>
    <input
      type="text"
      name="longitude"
      placeholder="Longitude"
      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
      value={selectedLocation?.lng || churchInputs?.longitude|| ""}
      onChange={handleChange}
    />
  </div>
{/* Repeat Every */}
<div className="md:col-span-2 col-span-1">
  <label className="text-[12px] text-greyish font-medium leading-4">
    Repeat Every *
  </label>
  <div className="flex gap-3 mt-2">
    {/* <input
      type="number"
      name="number"
      min="1"
      value={churchInputs?.repeatEvery?.number || 1}
      onChange={handleRepeatEveryChange}
      className="bg-blackish p-2 w-20 text-white text-[14px] font-medium rounded-md h-10"
    /> */}

    <select
      name="repeat"
      value={churchInputs?.repeat || "Weekly"}
      onChange={handleChange}
      className="bg-blackish p-2 text-white text-[14px] font-medium rounded-md h-10"
    >
      <option value="bi-weekly">Bi-Weekly</option>
      <option value="Weekly">Weekly</option>
      <option value="Monthly">Monthly</option>
    </select>
  </div>
</div>

  {/* Meeting Day - Bullet Style */}
{/* Repeat on */}
<div className="md:col-span-2 col-span-1 mt-4">
  <label className="text-[12px] text-greyish font-medium leading-4">
    Repeat on
  </label>

  {/* {churchInputs?.repeatEvery?.frequency === "Weekly" && ( */}
  <div className="flex flex-wrap gap-4 mt-3">
  {["Mon","Tue","Wed","Thr","Fri","Sat","Sun"].map((day) => {
    // Convert meetingday to string, then split by comma
    const selectedDays = (churchInputs?.meetingday || "").toString().split(",");
    const isChecked = selectedDays.includes(day);

    return (
      <label key={day} className="flex items-center gap-2 text-white text-sm">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={() => handleToggleMeetingDay(day)}
          className="appearance-none w-4 h-4 rounded-full border border-white checked:bg-yellowish checked:border-yellowish"
        />
        <span>{day}</span>
      </label>
    );
  })}
</div>


  {/* )} */}

{churchInputs?.repeatEvery?.frequency === "Monthly" && (
  <div className="mt-3">
    {/* Selected dates as pills */}
    {/* <div className="flex flex-wrap gap-2 mb-3">
      {(churchInputs?.meetingday || []).map((dateStr) => (
        <span
          key={dateStr}
          className="px-3 py-1 rounded-full bg-yellowish text-black font-medium text-sm flex items-center gap-2"
        >
          {dateStr}
          <button
            type="button"
            className="text-black hover:text-red-600"
            onClick={() => handleRemoveMonthlyDate(dateStr)}
          >
            ✕
          </button>
        </span>
      ))}
    </div> */}

    {/* Date picker */}
    {/* <DatePicker
      selected={parseISO(churchInputs?.meetingday?.[0] || todayStr)}
      onChange={(date) => handleAddMonthlyDate(date)}
      inline
      highlightDates={(churchInputs?.meetingday || []).map(parseISO)}
    /> */}

    {/* <p className="text-[12px] text-greyish mt-1">
      Click on calendar to add more dates
    </p> */}
  </div>
)}
</div>



  {/* Meeting Time Dropdown */}
  <div className="md:col-span-2 col-span-1">
    <label className="text-[12px] text-greyish font-medium leading-4">
      Starts at *
    </label>
    <select
      name="startmeetingtime"
      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
      onChange={handleChange}
      value={churchInputs?.startmeetingtime || ""}
    >
      <option value="" disabled>
        {churchInputs?.startmeetingtime || "Select Time"}

      </option>
      {[
    "12:00 AM",
"01:00 AM",
"02:00 AM",
"03:00 AM",
"04:00 AM",
"05:00 AM",
"06:00 AM",
"07:00 AM",
"08:00 AM",
"09:00 AM",
"10:00 AM",
"11:00 AM",
"12:00 PM",
"01:00 PM",
"02:00 PM",
"03:00 PM",
"04:00 PM",
"05:00 PM",
"06:00 PM",
"07:00 PM",
"08:00 PM",
"09:00 PM",
"10:00 PM",
"11:00 PM"

      ].map((time) => (
        <option key={time} value={time}>
          {time}
        </option>
      ))}
    </select>
  </div>
  <div className="md:col-span-2 col-span-1">
    <label className="text-[12px] text-greyish font-medium leading-4">
      Ends at *
    </label>
    <select
      name="meetingtime"
      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
      onChange={handleChange}
      value={churchInputs?.meetingtime || ""}
    >
      <option value="" disabled>

        {churchInputs?.meetingtime || "Select Time"}
      </option>
      {[
  "12:00 AM",
"01:00 AM",
"02:00 AM",
"03:00 AM",
"04:00 AM",
"05:00 AM",
"06:00 AM",
"07:00 AM",
"08:00 AM",
"09:00 AM",
"10:00 AM",
"11:00 AM",
"12:00 PM",
"01:00 PM",
"02:00 PM",
"03:00 PM",
"04:00 PM",
"05:00 PM",
"06:00 PM",
"07:00 PM",
"08:00 PM",
"09:00 PM",
"10:00 PM",
"11:00 PM"

      ].map((time) => (
        <option key={time} value={time}>
          {time}
        </option>
      ))}
    </select>
  </div>

  {/* Contact Person */}
  <div className="md:col-span-2 col-span-1">
    <label className="text-[12px] text-greyish font-medium leading-4">
      Contact Person *
    </label>
    <input
      name="contactperson"
      placeholder="Enter Contact Person"
      type="text"
      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
      value={churchInputs?.contactperson}
      onChange={handleChange}
    />
  </div>

  {/* Contact Phone */}
  <div className="md:col-span-1 col-span-1">
    <label className="text-[12px] text-greyish font-medium leading-4">
      Contact Phone *
    </label>
    <input
      name="contactphone"
      placeholder="Enter Contact Phone"
      type="tel"
      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
      value={churchInputs?.contactphone}
      onChange={handleChange}
    />
  </div>

  {/* Contact Email */}
  <div className="md:col-span-1 col-span-1">
    <label className="text-[12px] text-greyish font-medium leading-4">
      Contact Email *
    </label>
    <input
      name="contactemail"
      placeholder="Enter Contact Email"
      type="email"
      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
      value={churchInputs?.contactemail}
      onChange={handleChange}
    />
  </div>

  <div className="md:col-span-2 col-span-1">

  <GalleryPickerField
  label=" Cover Image"
  name="galleryImage"
  church={church}
  rowData={rowData}
  value={{
    web: { url: tumbNailUrlsInputs?.webUploadUrl },
    tablet: { url: tumbNailUrlsInputs?.tabletUploadUrl },
    mobile: { url: tumbNailUrlsInputs?.mobileUploadUrl },
  }}
  handleChange={handleGallerySelect}
/>
{/* <GalleryVideoField
        label="Select Video"
        name="thumbnail"
        church={church}

        handleChange={handleThumbSelect}
      />  */}
      {/* <div className="flex items-center gap-4 mt-4">
        <input
          type="checkbox"
          id="liveCheckbox"
          className="w-4 h-4 cursor-pointer accent-yellowish appearance-none border border-gray-300 rounded-full checked:bg-yellow-500 checked:border-yellow-500"
          checked={isLive}
          onChange={(e) => setIslive(e.target.checked)}
        />
        <label htmlFor="liveCheckbox" className="cursor-pointer select-none">
          Live
        </label>

        <input
          type="checkbox"
          id="defaultCheckbox"
          className="w-4 h-4 cursor-pointer accent-yellowish appearance-none border border-gray-300 rounded-full checked:bg-yellow-500 checked:border-yellow-500"
          checked={isDefault}
          onChange={(e) => setIsDefault(e.target.checked)}
        />
        <label htmlFor="defaultCheckbox" className="cursor-pointer select-none">
          Default
        </label>
      </div> */}
  </div>
{/* )} */}

</div>

              </div>
            </div>
            )}
            <Tooltip id="add_church" className="border border-greyish border-opacity-20" />
          </div>
        </div>
      </div>
      <CollapsibleRightPanel title="Stats / Layouts">
        <CustomTabsV2
          tabHeight={"h-[64px]"}
          tabsTitleArray={["Stats", "Layouts"]}
          tabsContentObject={{
            Stats: (
              <div className="mt-8 flex items-center justify-center w-full text-white">
                {data?._id ? (
                  <div className="w-full px-8">
                    <p>
                      Views : <strong>{videoInputs?.totalViews}</strong>
                    </p>
                    <p>
                      Likes: <strong>{videoInputs?.totalLikes}</strong>
                    </p>
                  </div>
                ) : (
                  <>No stats available for video</>
                )}
              </div>
            ),
            Layouts: !data?._id ? (
              <div className="mt-8 flex items-center justify-center w-full text-white">
                Save this Church to assign the layout
              </div>
            ) : (
              <>
                <div className="mt-4 p-1">
                  <label htmlFor="relatedVideos" className="text-[12px] text-greyish font-medium">
                    Layouts
                  </label>
                  <div className="bg-blackish py-4 px-3 mt-3 rounded-lg">
                    <LayoutDropdown
                      setMyState={setLayoutValues}
                      setLayoutInfo={setLayoutInfo}
                      setAddedLayout={setAddedLayout}
                      addedLayout={addedLayout}
                      newTarget={editTargetLayout}
                      isLayoutEdit={isLayoutEdit}
                      outerTargetLayout={layoutValues?.layout_name}
                    />

                    {layoutInfo && (
                      <>
                        <div className="flex gap-3">
                          <div className="w-full">
                            <label
                              htmlFor="order"
                              className="text-[12px] text-greyish font-medium leading-4 "
                            >
                              Display Order
                            </label>
                            <input
                              type="text"
                              className={`bg-greyishV2 p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10`}
                              name="order"
                              placeholder="Enter order"
                              value={layoutValues?.order}
                              onChange={handleVideoLayoutChange}
                            />
                          </div>
                        </div>
                        <div className="flex justify-end mt-4">
                          <div className="flex gap-3">
                            {!isLayoutEdit && (
                              <button
                                className="text-greyish bg-blackishV2 font-medium text-[12px] rounded-xl py-2 px-6"
                                onClick={() => {
                                  setLayoutValues(initialLayoutValues);
                                  setLayoutInfo(false);
                                }}
                              >
                                Cancel
                              </button>
                            )}
                            {isLayoutEdit ? (
                              <button
                                className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                                onClick={handleLayoutUpdate}
                              >
                                Confirm
                              </button>
                            ) : (
                              <button
                                className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                                onClick={handleAddLayoutToArray}
                              >
                                Add
                              </button>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {layoutArray?.length > 0 &&
                  activeTab === "en" &&
                  layoutArray?.map((item, index) => (
                    <div className="w-full px-4 mt-4">
                      <div className="w-full p-2 px-4 bg-black bg-opacity-10 rounded-lg border border-opacity-25 border-white">
                        <div className="flex flex-col items-center justify-center w-full text-white">
                          <div className="flex justify-between w-full">
                            <p className="text-sm font-white font-medium text-white">
                              {item?.layout_name}
                            </p>
                            <div className="flex gap-2 justify-end items-center cursor-pointer">
                              <img
                                className="h-4"
                                src={edit}
                                alt=""
                                onClick={() => {
                                  setIsLayoutEdit(true);
                                  setEditLayoutIndex(index);
                                  setLayoutValues(item);
                                  setEditTargetLayout(item?.layout_name);
                                }}
                              />
                              <img
                                className="h-4"
                                src={close}
                                alt=""
                                onClick={() => {
                                  handleDeleteLayoutFromArray(item?._id);
                                }}
                              />
                            </div>
                          </div>
                          <div className="flex justify-between w-full mt-5 bg-blackishV2 p-1 px-2">
                            <p className="text-[10px] font-white text-white">Order</p>
                          </div>
                          <div className="flex w-full mt-2 p-1 px-2">
                            <p className="flex w-full text-xs font-white font-bold text-white">
                              {item?.order}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </>
            ),
          }}
        />
      </CollapsibleRightPanel>

    </div>
  );
};

export default AddVideosFields;
